import BillingRecords from './BillingRecords'

export default BillingRecords
